export const POSITION_EVENTS = {
    scrapeRequested: 'scrape_requested',
    scrapeCompleted: 'scrape_completed',
    scrapeBypassed: 'scrape_bypassed',
    insightGenerated: 'insight_generated',
    insightUpdated: 'insight_updated',
    insightSent: 'insight_sent',
    feedbackRequested: 'feedback_requested',
    feedbackRatingStarted: 'feedback_rating_started',
    feedbackRatingUpdated: 'feedback_rating_updated',
    feedbackRatingCompleted: 'feedback_rating_completed',
    createJob: 'create_job',
    editJob: 'edit_job',
    chooseSamples: 'choose_samples',
    tips: 'tips',
    preliminaryFeedback: 'preliminary_feedback',
    complete: 'complete',
    calibrationRequest: 'calibration_request',
};

export const POSITION_EVENT_FLOW_TYPES = {
    feedback: 'feedback',
    positionWizard: 'positionWizard',
    insight: 'insight',
};
